import { TableInput } from 'models/general';
import { API_FUNCTIONS, RULES_ENDPOINTS, sdk } from 'utils/query';
import { RuleItem, RuleStatuses, RuleTypes } from 'models/rules';
import { PagedResultWithPager } from '@extrahorizon/javascript-sdk';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';

export const getPatientRulesRecords = async ({ pageParam, params, config, limit = 50 }: TableInput) => {
  const { patientId } = params;
  const { groupId } = config;
  if (!patientId || !groupId) throw new EmptyParametersError();

  const patientRules = await sdk.tasks.api.get<PagedResultWithPager<RuleItem>>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringRules}?recipientGroupIds=${groupId}&targetPatientId=${patientId}&targetGroupIds=${groupId}&limit=${limit}&offset=${pageParam * limit}`,
    {},
  );

  const data = patientRules?.data
    .map((value) => {
      if (value.targets.patientIds?.length > 0) {
        return { ...value, type: RuleTypes.individual, patientId, groupId };
      }

      return {
        ...value,
        type: RuleTypes.group,
        groupId,
        excluded: value.status === RuleStatuses.enabled && value.excludes.patientIds?.includes(patientId),
      };
    })
    .filter(
      (rule) =>
        rule.type === RuleTypes.individual || (rule.type === RuleTypes.group && rule.status === RuleStatuses.enabled),
    )
    .sort((a, b) => {
      const order = { individual: 0, group: 1 };
      return order[a.type as keyof typeof order] - order[b.type as keyof typeof order];
    });

  return { ...patientRules, data };
};

export const getGroupRulesRecords = async ({ pageParam, params, limit = 50 }: TableInput) => {
  const { groupId } = params;
  if (!groupId) throw new EmptyParametersError();

  const groupRules = await sdk.tasks.api.get<PagedResultWithPager<RuleItem>>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringRules}?targetGroupIds=${groupId}&limit=${limit}&offset=${pageParam * limit}`,
    {},
  );

  const data = groupRules?.data.map((value) => {
    return { ...value, groupId };
  });

  return { ...groupRules, data };
};
